import { createContext, useContext } from "react";

import type { MonthPickerContextValue } from "./MonthPicker.types";

export function makeMonthPickerContext({
  size = "md",
  layout = "default",
  disabled = false,
  arrow = true,
  locale = undefined,
  viewYear = new Date().getFullYear(),
  selected = null,
  min = null,
  max = null,
  pointerOffsetRef = { current: 0 },
  selectMonth = () => {},
  goToYear = () => {},
  goToView = () => {},
}: Partial<MonthPickerContextValue>): Required<MonthPickerContextValue> {
  return {
    size,
    layout,
    disabled,
    arrow,
    locale,
    viewYear,
    selected,
    min,
    max,
    pointerOffsetRef,
    selectMonth,
    goToYear,
    goToView,
  };
}

export const MonthPickerContext = createContext<
  Required<MonthPickerContextValue>
>(makeMonthPickerContext({}));

export function useMonthPickerContext() {
  return useContext(MonthPickerContext);
}
